/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Vs_Pr_Wins_3Inputs */

const en_fc_vs_pr_wins_3 = /** @type {(inputs: Fc_Vs_Pr_Wins_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deep Creative Cloud integration with After Effects, Audition and Frame.io.`)
};

/**
* | output |
* | --- |
* | "Deep Creative Cloud integration with After Effects, Audition and Frame.io." |
*
* @param {Fc_Vs_Pr_Wins_3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_vs_pr_wins_3 = /** @type {((inputs?: Fc_Vs_Pr_Wins_3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Vs_Pr_Wins_3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_vs_pr_wins_3(inputs)
});
export { fc_vs_pr_wins_3 as "fc.vs.pr_wins.3" }